import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';
import { Divider, FontIcon, RaisedButton } from 'material-ui';
import { FormattedMessage } from 'react-intl';

import styles from 'styles/TBenefits';
import KFlatButton from 'components/KJRN/KFlatButton';
import TLoading from './TLoading';
import TMessage from './TMessage';
import { fetchOpenEntry, initialize, punchInOut } from '../../sites/time/actions';
import PunchInTime from '../../sites/time/components/PunchInTime';
import ExpectedHours from '../../sites/time/components/ExpectedHours';
import Clock from '../../sites/time/components/Clock';

const TTime = () => {
  const dispatch = useDispatch();
  const {
    openEntryFetching, openEntryFetched, openEntryError, openEntry, openEntryErrorMessage,
    isPunching, isPunchedIn, initializeFailed, initializing, hasError, error,
  } = useSelector(state => state.timeReducer);

  useEffect(() => {
    dispatch(fetchOpenEntry());
    dispatch(initialize());
  }, []);

  if (openEntryFetching || (!openEntryFetched && !openEntryError) || initializing) {
    return <TLoading />;
  }
  if (openEntryError || hasError || initializeFailed) {
    return <TMessage type="error" message="tile.error" values={{ error: openEntryErrorMessage || error }} />;
  }
  return (
    <div style={styles.container} data-cy="entries">
      <div style={{
            maxHeight: 422, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
          }}
      >
        <ExpectedHours />
        <div style={{
              flex: 1, flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
        >
          <Clock />
          <div style={{ marginTop: 24, textAlign: 'center' }}>
            {isPunchedIn ?
              <RaisedButton style={{ marginBottom: 24 }} secondary icon={<FontIcon className="material-icons">alarm_off</FontIcon>} label={<FormattedMessage id="time.PunchOut" />} onClick={() => dispatch(punchInOut())} disabled={isPunching} />
              : <RaisedButton primary style={{ marginBottom: 24 }} icon={<FontIcon className="material-icons">alarm_on</FontIcon>} label={<FormattedMessage id="time.PunchIn" />} onClick={() => dispatch(punchInOut())} disabled={isPunching} />
              }
            <div style={{ height: 28 }}>
              {isPunchedIn ? <PunchInTime openEntry={openEntry} /> : null}
            </div>
          </div>
        </div>
      </div>
      <Divider style={{ marginTop: 'auto' }} />
      <KFlatButton
        data-cy="time-button"
        style={styles.actionButton}
        onClick={() => dispatch(push('/time'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.time.goto" />}
      />
    </div>
  );
};

export default TTime;



// WEBPACK FOOTER //
// ./src/containers/tiles/TTime.js